import { Box } from '@chakra-ui/react'
import { Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import { HeadingItem, ItemText } from 'uikit/Snippets'
import { getDateReadFormat } from 'shared/utils/dateFormatting'
import { useFetchEkengHistory } from './hooks/useFetchEkengHistory'

export const UserEditEkengHistory = ({ userId }) => {
  const { data, isLoading } = useFetchEkengHistory(userId)

  return (
    <Box>
      <Snippets
        columns="100px minmax(150px, 1fr) minmax(150px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) 120px 120px 150px 150px 80px 80px 120px 120px 50px"
        itemWidth="1800px"
      >
        <SnippetsHeading>
          <HeadingItem>Обновлено</HeadingItem>
          <HeadingItem>Фамилия</HeadingItem>
          <HeadingItem>Имя</HeadingItem>
          <HeadingItem>День рождения</HeadingItem>
          <HeadingItem>Паспорт</HeadingItem>
          <HeadingItem>Выдан</HeadingItem>
          <HeadingItem>Дата выдачи</HeadingItem>
          <HeadingItem>Дата окончания</HeadingItem>
          <HeadingItem>Улица</HeadingItem>
          <HeadingItem>Дом</HeadingItem>
          <HeadingItem>Квартира</HeadingItem>
          <HeadingItem>Община</HeadingItem>
          <HeadingItem>Регион</HeadingItem>
          <HeadingItem>Умер</HeadingItem>
        </SnippetsHeading>
        <SnippetsList
          data={data}
          isLoading={isLoading}
          hasMore={false}
          scrollableTarget="scrollableCardContainer"
        >
          {(item) => (
            <SnippetsItem>
              <ItemText>{getDateReadFormat(item?.updatedAt)}</ItemText>
              <ItemText>{item?.englishLastName}</ItemText>
              <ItemText>{item?.englishFirstName}</ItemText>
              <ItemText>{getDateReadFormat(item?.birthDate)}</ItemText>
              <ItemText>{item?.documentNumber}</ItemText>
              <ItemText>{item?.documentDepartment}</ItemText>
              <ItemText>{getDateReadFormat(item?.issuanceDate)}</ItemText>
              <ItemText>{getDateReadFormat(item?.validityDate)}</ItemText>
              <ItemText>{item?.street}</ItemText>
              <ItemText>{item?.building}</ItemText>
              <ItemText>{item?.apartment}</ItemText>
              <ItemText>{item?.community}</ItemText>
              <ItemText>{item?.region}</ItemText>
              <ItemText>{item?.ekengData?.isDead ? 'Да' : 'Нет'}</ItemText>
            </SnippetsItem>
          )}
        </SnippetsList>
      </Snippets>
    </Box>
  )
}
